import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSTipoPedidoEstabService from '@/services/SistemaDKP/SLSTipoPedidoEstab.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSTipoPedidoEstabService = new SLSTipoPedidoEstabService();
  const refTipoPedidoEstabListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'tipopedidoid', label: 'Tipo Pedido', sortable: false },
    { key: 'estabelecimentoid', label: 'Estabelecimento', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalTipoPedidoEstab = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('tipopedidoid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refTipoPedidoEstabListTable.value ? refTipoPedidoEstabListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTipoPedidoEstab.value,
    };
  });

  const refetchData = () => {
    refTipoPedidoEstabListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchTipoPedidoEstab = (ctx, callback) => {
    overlay.value = true;
    sLSTipoPedidoEstabService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      // console.log(data);
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalTipoPedidoEstab.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    try {
      const response = await sLSTipoPedidoEstabService.store(body);

      if (response || (response.status >= 200 && response.status < 300)) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Tipo Pedido X Estabelecimento cadastrado com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        refetchData();
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Tipo Pedido X Estabelecimento não foi cadastrado.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }
    } catch (error) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Tipo Pedido X Estabelecimento não foi cadastrado.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };

  const Updated = async (body) => {
    const response = await sLSTipoPedidoEstabService.update(body);
    if (response) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Tipo Pedido X Estabelecimento atualizado com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    } else {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Tipo Pedido X Estabelecimento não foi atualizado.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
    refetchData();
  };

  const removerData = async (id) => {
    await sLSTipoPedidoEstabService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchTipoPedidoEstab,
    tableColumns,
    perPage,
    currentPage,
    totalTipoPedidoEstab,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTipoPedidoEstabListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    Updated,
    create,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
